<template>
  <div
      class="md:flex md:space-x-5 email_height overflow-hidden relative rtl:space-x-reverse"
  >
    <div
        class="flex-1 md:w-[calc(100%-320px)]"
        :class="width < 768 ? 'h-full' : ''"
    >
      <Card
          bodyClass="p-0 h-full  relative"
          :className="width < 1024 ? 'h-full' : ''"
      >
        <div class="all-allEmails px-6 h-full flex flex-col pt-6 pb-4">
          <Transition :enter-active-class="locale === 'fa' ? 'singleEmail-fa-enter-active' : 'singleEmail-enter-active'"
                      :leave-active-class="locale === 'fa' ? 'singleEmail-fa-leave-active' : 'singleEmail-leave-active'"
                      name="singleEmail">
            <accountDetails/>
          </Transition>
        </div>
      </Card>
    </div>
  </div>
</template>
<script setup>
import Card from "@/components/Card/index.vue";
import {computed, ref, onMounted} from "vue";
import {useEmailStore} from "@/stores/email";
import AccountDetails from "@/views/kyc/accountDetails/details.vue";
import {useI18n} from "vue-i18n";

const width = ref(0);
const handleResize = () => {
  width.value = window.innerWidth;
};
onMounted(() => {
  window.addEventListener("resize", handleResize);
  handleResize();
});

let store = useEmailStore();


const {locale} = useI18n({useScope: 'global'})
</script>
<style lang="scss">
.singleEmail-enter-active {
  animation: fade-in-right 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.singleEmail-leave-active {
  animation: fade-in-right 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both reverse;
}

.singleEmail-fa-enter-active {
  animation: fade-in-left 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both;
}

.singleEmail-fa-leave-active {
  animation: fade-in-left 0.5s cubic-bezier(0.39, 0.575, 0.565, 1) both reverse;
}

@-webkit-keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fade-in-right {
  0% {
    -webkit-transform: translateX(50px);
    transform: translateX(50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}


@-webkit-keyframes fade-in-left {
  0% {
    -webkit-transform: translateX(-50px);
    transform: translateX(-50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes fade-in-left {
  0% {
    -webkit-transform: translateX(-50px);
    transform: translateX(-50px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}


@-webkit-keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

@keyframes slide-in-right {
  0% {
    -webkit-transform: translateX(1000px);
    transform: translateX(1000px);
    opacity: 0;
  }
  100% {
    -webkit-transform: translateX(0);
    transform: translateX(0);
    opacity: 1;
  }
}

.email_height {
  height: calc(var(--vh, 1vh) * 100 - 12.1rem);
}

@media (max-width: 768px) {
  .email_height {
    height: calc(var(--vh, 1vh) * 100 - 10.5rem);
  }
}
</style>
